// extracted by mini-css-extract-plugin
module.exports = {"screen":"LoginScreen_screen__3jNFh","container":"LoginScreen_container___rK2f","button":"LoginScreen_button__Iq5KD","info":"LoginScreen_info__1tB9V"};